import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

iZtoast.settings({
    timeout: 6000,
    transitionIn: 'flipInX',
    transitionOut: 'flipOutX'
});

const toast = {
    error: (message, title = '') => {
        return iZtoast.error({
            title: title,
            message: message,
            position: 'topRight',
            messageColor: "#ffffff"
        });
    },
    warning: (message, title = '') => {
        return iZtoast.warning({
            title: title,
            message: message,
            position: 'topRight',
            messageColor: "#ffffff"
        });
    },
    info: (message, title = '') => {
        return iZtoast.info({
            title: title,
            message: message,
            position: 'topRight',
            messageColor: "#ffffff"
        });
    },
    success: (message, title = '') => {
        return iZtoast.success({
            title: title,
            message: message,
            position: 'topRight',
            messageColor: "#ffffff"
        });
    },
    question: (message) => {
        message = message ? message : 'An unexpected error has occurred. please contact the system administrator.';
        return iZtoast.question({
            timeout: 20000000,
            close: false,
            overlay: true,
            displayMode: 'once',
            id: 'question',
            messageColor: "#ffffff",
            zindex: 999,
            title: '',
            message: message,
            position: 'center',
            buttons: [
                ['<button><b>OK</b></button>', function (instance, toast) {

                    instance.hide({
                        transitionOut: 'fadeOut'
                    }, toast, 'button');

                }, true]
            ],          
            onClosed: function (instance, toast, closedBy) {
                window.location.reload();
            }
        });
    },
};

export default toast;